<ion-content>
  <div class="full-width-height vertical-center ion-padding-vertical">
    <ion-card class="sms-promo-card center" [class]="voucher?.voucherId ? ('card-' + voucher.voucherId) : ''" [color]="redeemMode ? 'primary' : ''">
      <!-- <ion-item class="background-transparent" lines="none">
        <ion-button class="ion-no-margin"  fill="clear" color="dark" slot="end" (click)="dismissModal()">
          <ion-icon class="font-20" [ngClass]="'close-btn-' + voucher?.voucherId" name="close" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-item> -->
      <div class="close-btn-div">
        <ion-button class="close-btn ion-no-margin" fill="clear" color="dark" (click)="dismissModal()">
          <ion-icon class="font-30" [ngClass]="'close-btn-' + voucher?.voucherId" name="close" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
      <div>
        <div>
          <ng-container *ngIf="!redeemMode">
            <ng-container *ngIf="voucher?.voucherId === 'Valentine2023'">
              <div>
                <ion-img class="valentine-ballons promo-img full-width center" [src]="'./assets/wedding/img/news/promo/valentine/ballons.svg'"></ion-img>
              </div>
              <div>
                <ion-img class="full-width promo-img" [src]="'./assets/wedding/img/news/promo/valentine/title_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div>
          <div *ngIf="!redeemMode">

            <ng-container *ngIf="voucher?.voucherId === 'Valentine2023'">
              <ng-container *ngIf="voucher?.voucherId === 'Valentine2023'">
                <ion-img class="promo-img full-width" [src]="'./assets/wedding/img/news/promo/valentine/msg_' + language + '.svg'"></ion-img>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'FebPayDay23'">
              <div>
                <ion-img class="promo-img payday-title full-width center" [src]="'./assets/wedding/img/news/promo/FebPayDay23/title_' + language + '.svg'"></ion-img>
              </div>
              <div class="ion-margin-vertical">
                <ion-img class="promo-img payday-img full-width center" [src]="'./assets/wedding/img/news/promo/FebPayDay23/main.svg'"></ion-img>
              </div>
              <div class="ion-margin-vertical">
                <ion-img class="promo-img payday-msg full-width center" [src]="'./assets/wedding/img/news/promo/FebPayDay23/msg_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '03032023'">
              <div class="ion-margin-vertical">
                <ion-img class="promo-img threethree-img center" [src]="'./assets/wedding/img/news/promo/03032023/banner_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'WomensDay23'">
              <div>
                <ion-img class="promo-img womensday-title full-width center" [src]="'./assets/wedding/img/news/promo/WomensDay23/title_' + language + '.svg'"></ion-img>
              </div>
              <div class="ion-margin-vertical">
                <ion-img class="promo-img womensday-img full-width center" [src]="'./assets/wedding/img/news/promo/WomensDay23/main.svg'"></ion-img>
              </div>
              <div class="ion-margin-vertical">
                <ion-img class="promo-img womensday-msg full-width center" [src]="'./assets/wedding/img/news/promo/WomensDay23/msg_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'MarPayDay23'">
              <div>
                <ion-img class="promo-img full-width center" [ngClass]="'title-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/MarPayDay23/title_' + language + '.svg'"></ion-img>
              </div>
              <div class="ion-margin-vertical">
                <ion-img class="promo-img full-width center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/MarPayDay23/main.svg'"></ion-img>
              </div>
              <div class="ion-margin-vertical ion-padding-vertical">
                <ion-img class="promo-img full-width center" [ngClass]="'msg-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/MarPayDay23/msg_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '04042023'">
              <div>
                <ion-img class="promo-img full-width center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/04042023/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'Easter23'">
              <div>
                <ion-img class="promo-img full-width center" [ngClass]="'img-' + voucher?.voucherId" [src]="'./assets/wedding/img/news/promo/Easter23/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'Ramadan23'">
              <div>
                <ion-img class="promo-img full-width center" [ngClass]="'img-' + voucher?.voucherId" [src]="'./assets/wedding/img/news/promo/Ramadan23/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'LabourDay23'">
              <div>
                <ion-img class="promo-img full-width center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/May/LabourDay23/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === '05052023'">
              <div>
                <ion-img class="promo-img full-width center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/May/05052023/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'MotherDay23'">
              <div>
                <ion-img class="promo-img full-width center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/May/MotherDay23/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === '5202023'">
              <div>
                <ion-img class="promo-img full-width center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/May/5202023/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'MayPayDay23'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/May/MayPayDay23/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'DragonBoat23'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/June/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'FatherDay23'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/June/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'Haji23'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/June/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '07072023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/July/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'MidYear2023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/July/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'Summer2023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/July/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'SG58th'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'SurpriseAug23'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'Merdeka66th'">
              <div>
                <ion-img class="promo-img width-100 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '09092023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'MalaysiaDay2023'">
              <div>
                <ion-img class="promo-img width-100 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'MidAutumn23'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '10102023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Oct/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'Halloween2023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Oct/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '11112023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Nov/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'BlackFriday2023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Nov/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '12122023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Dec/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'Christmas2023'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Dec/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'Year2024'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Jan/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'JanPayDay24'">
              <div>
                <ion-img class="promo-img width-90 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Jan/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'CNY2024'">
              <div>
                <ion-img class="promo-img width-85 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Feb/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'FebPayDay24'">
              <div>
                <ion-img class="promo-img width-80 center" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Feb/' + voucher.voucherId + '/iap_' + language + '.svg'"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'WomensDay2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Mar/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
            <ng-container *ngIf="voucher?.voucherId === 'Ramadan2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Mar/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '04042024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Apr/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'Raya2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Apr/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'MothersDay2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/May/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '5202024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/May/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '06062024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Jun/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'Haji2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Jun/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '07072024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Jul/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'MidYearSale24'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Jul/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'TogetherSG59'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'Merdeka67th'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Aug/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '09092024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'MalaysiaDay2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Sep/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '10102024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Oct/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'Halloween2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Oct/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '11112024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Nov/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'BlackFriday2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Nov/' + voucher.voucherId + '/iap_' + language + '.png'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === '12122024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Dec/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>

            <ng-container *ngIf="voucher?.voucherId === 'Christmas2024'">
              <div class="banner-div">
                <ion-img class="banner-img" [ngClass]="'img-' + voucher.voucherId" [src]="'./assets/wedding/img/news/promo/Dec/' + voucher.voucherId + '/iap_' + language + '.svg'" slot="start"></ion-img>
              </div>
            </ng-container>
          </div>
        </div>
        
        <div class="ion-margin ion-padding" [ngClass]="'btn-div-' + voucher?.voucherId">
          <ion-button [ngClass]="'btn-' + voucher?.voucherId" expand="block" [color]="redeemMode ? 'white' : ''" (click)="select()">
            {{ 'BTN.get_it_now' | translate }}
          </ion-button>
        </div>
      </div>
    </ion-card>
  </div>
</ion-content>